import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import {
  PageWizardProvider,
  PageWizardRoutes,
} from "shared/components/layout/PageWizard";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const CreditFacilityExpenseWorkflow: React.FC = () => {
  const { t } = useTranslation(["creditFacility"]);
  const { fundFamilyId, creditFacilityId } = useRequiredStringParams();

  const navigate = useNavigate();

  const backToExpenseTab = useCallback(() => {
    navigate(
      rootRoute({})
        .fundFamilies({})
        .fundFamily({ fundFamilyId })
        .creditFacilities({})
        .creditFacility({ creditFacilityId })
        .expenses({}).$,
    );
  }, [navigate, fundFamilyId, creditFacilityId]);

  return (
    <PageWizardProvider
      finishTitle={t("creditFacility:postExpense.type")}
      onExit={backToExpenseTab}
      allowNavigate={false}
    >
      <PageWizardRoutes />
    </PageWizardProvider>
  );
};
